export { default as TextInput } from './TextInput';
export * as Styled from './TextInput.styles';
export * from './TextInput.types';
